import React from "react";
import dayjs from "dayjs";
import { Remarkable } from "remarkable";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useMediaQuery } from "react-responsive";
import { LinkedInIco, TwitterIco, FacebookIco, Instagram } from "@speedoc/design-assets/build/icons";

const markdown = new Remarkable();

const PostAuthor = ({ children }) => {
  return <div className="blogHeaderAuthor">By {children}</div>;
};

const PostDate = ({ children }) => {
  return <div className="blogHeaderDate">{dayjs(children).format("MMMM DD, YYYY")}</div>;
};

export default function Header({ data, date }) {
  const { h1: title, content, heroImage, author } = data;
  const isMobile = useMediaQuery({ query: "(max-width: 1100px)" });

  return (
    <div id="blogHeader">
      {isMobile ? (
        <div className="heroFlatMobile">
          <div className="header">{title}</div>
          <div className="image">
            <LazyLoadImage src={heroImage.formats?.small?.url} alt={heroImage.alternativeText} />
          </div>
          <div className="description" dangerouslySetInnerHTML={{ __html: markdown.render(content) }} />
        </div>
      ) : (
        <div className="heroFlatDesktop">
          <div className="heroLeft">
            <div className="image">
              <LazyLoadImage src={heroImage.formats?.small?.url} alt={heroImage.alternativeText} />
            </div>
          </div>
          <div className="heroRight">
            <div className="header">{title}</div>
            <div className="description" dangerouslySetInnerHTML={{ __html: markdown.render(content) }} />
            <div className="blogHeaderAuthorDate">
              <PostAuthor>{`${author}, `}</PostAuthor>&nbsp;<PostDate>{date}</PostDate>
              <div className="blogHeaderSocialMedia">
                <a href={process.env.REACT_APP_LINKEDIN} rel="noopener noreferrer" target="_blank">
                  <LinkedInIco />
                </a>
                <a href={process.env.REACT_APP_FACEBOOK} rel="noopener noreferrer" target="_blank">
                  <FacebookIco />
                </a>
                <a
                  href={process.env.REACT_APP_INSTAGRAM}
                  rel="noopener noreferrer"
                  target="_blank"
                  className="instagram">
                  <Instagram />
                </a>
                <a href={process.env.REACT_APP_TWITTER} rel="noopener noreferrer" target="_blank">
                  <TwitterIco />
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
